import {
  DisplayCaptureDirectionEnum,
  DisplayCaptureStateEnum,
} from "../../models/enums";

export enum DisplayCaptureActions {
  DISPLAY_CAPTURE_STATE_CHANGE = "DISPLAY_CAPTURE_STATE_CHANGE",
  DISPLAY_CAPTURE_ERROR = "DISPLAY_CAPTURE_ERROR",
  DISPLAY_CAPTURE_DIRECTION_CHANGE = "DISPLAY_CAPTURE_DIRECTION_CHANGE",
}

export interface DisplayCaptureStateChange {
  type: DisplayCaptureActions.DISPLAY_CAPTURE_STATE_CHANGE;
  payload: DisplayCaptureStateEnum;
}
export interface DisplayCaptureError {
  type: DisplayCaptureActions.DISPLAY_CAPTURE_ERROR;
  payload: Error;
}

export interface DisplayCaptureDirectionChange {
  type: DisplayCaptureActions.DISPLAY_CAPTURE_DIRECTION_CHANGE;
  payload: DisplayCaptureDirectionEnum;
}

export const dispatchDisplayCaptureStateChange =
  (payload: DisplayCaptureStateEnum) => (dispatch, _getState) => {
    return dispatch({
      type: DisplayCaptureActions.DISPLAY_CAPTURE_STATE_CHANGE,
      payload,
    } as DisplayCaptureStateChange);
  };

export const dispatchDisplayCaptureError =
  (payload: Error) => (dispatch, _getState) => {
    return dispatch({
      type: DisplayCaptureActions.DISPLAY_CAPTURE_ERROR,
      payload,
    } as DisplayCaptureError);
  };

export const dispatchDisplayCaptureDirectionChange =
  (payload: DisplayCaptureDirectionEnum) => (dispatch, _getState) => {
    return dispatch({
      type: DisplayCaptureActions.DISPLAY_CAPTURE_DIRECTION_CHANGE,
      payload,
    } as DisplayCaptureDirectionChange);
  };
